import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const DeleteButton = ({ text, label, className, onClick }) => {
  return (
    <button
      className={classNames(
        'btn btn-link text-decoration-underline',
        className,
      )}
      aria-label={label}
      onClick={onClick}
      type="button">
      <i className="fas fa-trash-alt mr-1" aria-hidden="true"></i>
      {text}
    </button>
  );
};

DeleteButton.propTypes = {
  text: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  className: PropTypes.string,
  onClick: PropTypes.func,
};

export { DeleteButton };
